import { ref } from 'vue'
import { Subtask } from '@/api/pathways/subtasks/types'
import { getLinkedActivePlannedCall } from './useLinkedPlannedCallCheck'

export interface LinkedCall {
  patientId: string
  commId: string
}

/**
 * Composable to manage PlannedCallBlockModal state and behavior.
 * Encapsulates the modal visibility state, linked call, and
 * the logic to open the modal for a given subtask.
 * @returns Modal state and handler function
 */
export function usePlannedCallBlockModal() {
  const showPlannedCallBlockModal = ref(false)
  const linkedCall = ref<LinkedCall | null>(null)

  /**
   * Opens the planned call block modal for a given subtask.
   * If linkedCallParam is provided, uses it directly.
   * Otherwise, fetches linked communications to get the planned call.
   * @param subtask - The subtask linked to a planned call
   * @param linkedCallParam - Optional pre-fetched linked call to avoid re-fetching
   */
  async function openPlannedCallBlockModal(
    subtask: Subtask,
    linkedCallParam?: LinkedCall | null
  ) {
    if (linkedCallParam !== undefined) {
      linkedCall.value = linkedCallParam
    } else {
      const call = await getLinkedActivePlannedCall(subtask)
      linkedCall.value = call
        ? { patientId: call.patientId, commId: call.communicationId }
        : null
    }
    showPlannedCallBlockModal.value = true
  }

  return {
    showPlannedCallBlockModal,
    linkedCall,
    openPlannedCallBlockModal,
  }
}
